// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Share from "vue-social-share";
import "../static/client.css";
import App from "./App";
import router from "./router";
import store from "./store";
import "mint-ui/lib/style.css";
import MintUI from "mint-ui";
import { Slider, Swipe, SwipeItem, Popup, Icon } from "vant";
import { Image as VanImage } from "vant";
import directives from "@/utils/plugins.js";
import htmlapi from "@/utils/interface.js";
import "quill/dist/quill.core.css"; // 引入样式
import "quill/dist/quill.snow.css"; // snow theme
import "quill/dist/quill.bubble.css"; // bubble theme
import { EventBus } from "./Eventbus";
import axios from "axios";
import 'hover.css'
import 'flex.css'
Vue.prototype.$axios = axios;
Vue.prototype.$htmlapi = htmlapi.commonUrl;
Vue.prototype.$EventBus = EventBus;

Vue.use(directives);
// 2. 引入组件样式
import "vant/lib/index.css";
// 引用xml-digital-teaching组件库
import XML from "./plugins/xml-digital-teaching/lib/index";
import "./plugins/xml-digital-teaching/lib/theme/index.css";
import * as uni from "@/utils/uniwebview.js";
import 'vue-easytable/libs/theme-default/index.css'
// 引入rem.js
import "./utils/rem";
document.addEventListener("UniAppJSBridgeReady", function () {
  Vue.prototype.myUni = uni;
  console.log("uni", uni);
});
Vue.use(XML);
Vue.use(MintUI);
Vue.use(Slider);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(VanImage);
Vue.use(Icon);

import "./permission";
import "@/components/akTooltipAutoShow";
import * as ruoyi from "@/utils/ruoyi"; // 若依公共方法
import * as filters from "./filters"; // global filters
Vue.prototype.$store = store;

// 字典数据组件
import DictData from '@/components/DictData';
import { getDicts } from '@/api/system/dict/data';
import '@/components/BusinessComponents';
// 字典标签组件
import DictTag from '@/components/DictTag';
// 全局组件挂载
Vue.component('DictTag', DictTag);
Vue.prototype.getDicts = getDicts;
DictData.install();
Vue.use(ElementUI);
Vue.use(Share);
Vue.config.productionTip = false;
Object.keys(ruoyi).forEach((key) => {
  Vue.prototype[key] = ruoyi[key];
});
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
/* eslint-disable no-new */

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
